import CustomerFilterField from "@/components/CustomerFilterField.jsx";
import FilterToolboxShell from "@/components/FilterToolboxShell.jsx";

export default function CustomerLineFilterToolbox({
    filters,
    loading = false,
    onChange,
    onApply,
    onReset
}) {
    return (
        <FilterToolboxShell loading={loading} onApply={onApply} onReset={onReset}>
            {({ closeMobile }) => (
                <>
                    <label className="field">
                        Recherche
                        <input
                            type="search"
                            placeholder="Titre ou catégorie…"
                            value={filters.search}
                            onChange={(e) => onChange({ ...filters, search: e.target.value })}
                        />
                    </label>

                    <CustomerFilterField
                        value={filters.customer}
                        onChange={(customer) => onChange({ ...filters, customer })}
                        onCustomerSelect={async (customer) => {
                            const nextFilters = { ...filters, customer };
                            onChange(nextFilters);
                            await onApply(nextFilters);
                            closeMobile();
                        }}
                        disabled={loading}
                    />

                    <label className="field field--date">
                        Date à partir du
                        <input
                            type="date"
                            value={filters.dateFrom}
                            onChange={(e) => onChange({ ...filters, dateFrom: e.target.value })}
                        />
                    </label>

                    <label className="field field--date">
                        Date jusqu&apos;au
                        <input
                            type="date"
                            value={filters.dateTo}
                            onChange={(e) => onChange({ ...filters, dateTo: e.target.value })}
                        />
                    </label>
                </>
            )}
        </FilterToolboxShell>
    );
}
